<template>
  <v-container fluid>
    <v-card
        elevation="12"
        :loading="isLoading"
        width="384"
        class="mx-auto"
    >
      <!-- Progress -->
      <template v-slot:progress>
        <v-progress-linear
            indeterminates
            color="primary"
        ></v-progress-linear>
      </template>

      <v-card-title class="justify-center">
        <v-img
            :src="imgLogo"
            contain
            aspect-ratio="3"
            max-height="150"
        ></v-img>
      </v-card-title>

      <v-card-subtitle class="text-center">
        <h2 class="green--text">Inicio de sesión</h2>
      </v-card-subtitle>

      <!-- Form -->
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-form
                ref="loginForm"
                @submit.prevent="login"
                v-model="isValidForm"
                lazy-validation
            >
              <v-row>
                <v-col cols="12">
                  <v-text-field
                      v-model="username"
                      label="Nombre de usuario"
                      required
                      :rules="[rules.required]"
                  />
                </v-col>
                <v-col cols="12">
                  <v-text-field
                      v-model="password"
                      label="Contraseña"
                      required
                      :type="isPasswordVisible ? 'text' : 'password'"
                      :append-icon="isPasswordVisible ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="isPasswordVisible = !isPasswordVisible"
                      :rules="[rules.required]"
                  />
                </v-col>
                <v-col cols="12">
                  <v-btn
                      color="success"
                      @click="login"
                      :disabled="!isValidForm"
                      :loading="isLoading"
                      block
                  >
                    <v-icon left>mdi-login</v-icon>
                    Iniciar sesión
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-col>
        </v-row>

        <!-- Forgot password -->
        <v-row>
          <v-col cols="12" class="text-center">
            <a @click="() => $router.push('/forgot-password')">¿Olvidaste tu contraseña?</a>
          </v-col>
        </v-row>

        <!-- Contact -->
        <v-row>
          <v-col cols="4" class="text-center">
            <small>
              <a href="https://dietec.mx/contacto" target="_blank">
                Contáctanos
              </a>
            </small>
          </v-col>
          <v-col cols="4" class="text-center">
            <small>
              <a href="https://dietec.mx/t%C3%A9rminos-y-condiciones" target="_blank">
                Términos y condiciones
              </a>
            </small>
          </v-col>
          <v-col cols="4" class="text-center">
            <small>
              <a href="https://dietec.mx/aviso-de-privacidad" target="_blank">
                Aviso de privacidad
              </a>
            </small>
          </v-col>
        </v-row>

        <!-- Copyright -->
        <v-row>
          <v-col cols="12" class="text-center">
            <small>&copy; 2018 - {{ currentYear }} | DIETEC SDR v2.3</small>
          </v-col>
        </v-row>
      </v-card-text>

    </v-card>
  </v-container>
</template>

<script lang="ts">
import Vue from 'vue';
import {RequestLogin} from "@/services/auth/entities/RequestLogin";

export default Vue.extend({
  name: 'LoginPage',
  data: () => ({
    // Form
    username: '' as string,
    password: '' as string,

    // State
    isLoading: false as boolean,
    isPasswordVisible: false as boolean,
    isValidForm: false as boolean,

    // Assets
    imgLogo: require('@/assets/images/logos/logo.png') as string,
    currentYear: new Date().getFullYear() as number,

    // Validation
    rules: {
      required: (value: string) => !!value || 'Este campo es requerido.',
    }
  }),

  methods: {
    async login(): Promise<void> {
      const form = this.$refs.loginForm as any;
      if (!form.validate()) return;
      this.isLoading = true;
      try {
        const body: RequestLogin = {
          username: this.username,
          password: this.password,
        }
        await this.$store.dispatch('auth/login', body);
        await this.$store.dispatch('balance/updateRoyalties', body);
        await this.$router.push('/');
      } finally {
        this.isLoading = false;
      }
    },

    handleEnter(event: KeyboardEvent) {
      if (event.key === "Enter" && this.username && this.password) {
        this.login();
      }
    },
  },

  mounted() {
    document.addEventListener("keyup", this.handleEnter);
  },

  beforeDestroy() {
    document.removeEventListener("keyup", this.handleEnter);
  },

  created() {
    if (this.$store.getters['auth/isAuthenticated']) {
      this.$router.push('/');
    }
  }
});
</script>

<style scoped>

</style>
